module.exports = "/fonts/fa-regular-400.ttf?59215032a4397507b80e5625dc323de3";